import * as React from 'react';
import * as IoC from 'typescript-ioc';
import * as mobxReact from 'mobx-react';
import { AuthAggregateProvider } from '../domain/auth/implementations/auth-aggregate-provider';
import { IRouter } from '../infrastructure/router';
import { RouteParams } from '../routes-table';
import { IRuntimeConfiguration } from '../infrastructure/runtime-configuration';
import TrackingServiceProvider from '../tracking-service/tracking-service-provider';
import { AuthServiceConfigurator } from '../domain/auth/implementations/auth-service-configurator';

@mobxReact.observer
class AuthGuard extends React.Component {
    private authProvider: AuthAggregateProvider;
    private routingService: IRouter<RouteParams>;
    private runtimeConfiguration: IRuntimeConfiguration;
    private serviceConfigurator: AuthServiceConfigurator;
    private readonly invalidRequest = 'invalid_request';
    private readonly errorDescription = 'Already+found+an+entry+for+username';

    private trackingService: TrackingServiceProvider;

    constructor(props, context) {
        super(props, context);

        this.authProvider = IoC.Container.get(AuthAggregateProvider);
        this.routingService = IoC.Container.get(IRouter);
        this.runtimeConfiguration = IoC.Container.get(IRuntimeConfiguration);
        this.trackingService = IoC.Container.get(TrackingServiceProvider);
        this.serviceConfigurator = IoC.Container.get(AuthServiceConfigurator);
    }

    public render() {
        const authProvider = this.authProvider.get();

        if (authProvider && authProvider.isAuthenticated() && authProvider.isPermissionAvailable()) {
            return this.props.children;
        } else {
            return <div>authentication is being performed</div>;
        }
    }

    /* eslint-disable @typescript-eslint/no-floating-promises */
    public async componentDidMount(): Promise<void> {
        await this.authProvider.init();
        const authAggregate = this.authProvider.get();
        const sessionToken = await authAggregate.getSessionToken();

        if (sessionToken == null) {
           if (this.needToRestartAuthFlow()) {
                await authAggregate.logout();
           } else {
                await authAggregate.authenticate();
            }
        } else {
            await authAggregate.getUserPermissions();

            /* services to be configured for the authenticated user */
            await this.serviceConfigurator.configureAmplify();
            const user = await authAggregate.getCurrentUser();
            await this.serviceConfigurator.configureTrackingService(sessionToken, user);
        }
    }

    private needToRestartAuthFlow() {
        const searchParams = (new URL(location.href)).searchParams;
        const errorDescription = searchParams.get('error_description');
        const errorCode = searchParams.get('error');
        return errorCode === this.invalidRequest && errorDescription.startsWith(this.errorDescription);
    }

}

export { AuthGuard };
